module.exports = __webpack_public_path__ + "assets/img/car20.55b6bb9a.jpg";